<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogMangeAuthen" persistent max-width="1000px">
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">เลือกสิทธิ์ที่ต้องการคงไว้อยู่</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- <v-col cols="4">
            <v-autocomplete
              v-model="dataSearchEmployee"
              :items="itemUser"
              item-text="name"
              item-value="_id"
              outlined
              dense
              clearable
              class="create-orgchart-type mt-2"
              placeholder="ค้นหา พนักงาน"
              no-data-text="ไม่พบข้อมูล"
              single-line
            >
            </v-autocomplete>
          </v-col> -->
          <v-col cols="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              outlined
              dense
              clearable
              class="mt-0"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              class="border-table-employee text-no-wrap mt-1"
              item-key="_id"
              v-model="selected"
              :headers="headers"
              :items="dataSource"
              :items-per-page="5"
              :loading="loading"
              :search="search"
              :expanded.sync="expanded"
              loader-height=0
              loading-text="Loading... Please wait"
              @update:items-per-page="changePerPage"
              @update:page="changePage"
              :single-select="singleSelect"
              :show-select="true"
              @input="checkAllowBtn()"
              @toggle-select-all="selectAllToggle"
              disable-sort
            >
            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-checkbox
                v-show="true"
                v-model="item.selected"
                :value="isSelected"
                hide-details
                class="ma-0"
                style="width: 0px;"
                @change="select($event)"
              />
            </template>
            <template v-slot:[`item.no`]="{ item }">
              {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    icon
                    tile
                    class="ra-border-button mr-2"
                    @click="checkCancel(item)"
                  >
                  <v-icon dark color="error" >mdi-close</v-icon>
                  </v-btn>
                </template>
                <span class="label-table-action">ลบสิทธิ์</span>
              </v-tooltip>
            </template>
            <template v-slot:item.data-table-expand="{ item }">
          <v-row class="d-flex px-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  icon
                  tile
                  class="ra-border-button mr-2"
                  @click="checkCancel(item)"
                >
                <v-icon dark color="error" >mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">ลบสิทธิ์</span>
            </v-tooltip>
          </v-row>
        </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- <FullLoading :loading="loadingUsers"></FullLoading> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#1654C6" outlined @click="closeDialog">ยกเลิก</v-btn>
        <v-btn v-if="checkBtnSubmit === false" class="ra-button1" color="grey" depressed disabled>ยืนยัน</v-btn>
        <v-btn v-else class="ra-button1" color="#1654C6" dark @click="confirmUpdate()">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogConfirmCancel" max-width="500px">
    <v-card height="180px">
      <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกสิทธิ์นี้ใช่ไหม</v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสิทธิ์</span>
      </v-card-text>
      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmCancel = false">ยกเลิก</v-btn>
        <v-btn class="ra-button1" color="#1654C6" dark @click="submitCancelRole()">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import
{
  getSelectManageAuthen,
  fetchAllRequestAuthen
  // hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'
const moment = require('moment')
const axios = require('axios')

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      search: '',
      expanded: [],
      menu: false,
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogMangeAuthen: false,
      dialogConfirmCancel: false,
      selected: [],
      itemUser: [],
      total: -1,
      perPage: 15,
      page: 1,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      // approveRole: localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader',
      approveRole: localStorage.approveRole,
      searchEmpoyee: '',
      dataSearchEmployee: '',
      selectAuthenItem: '',
      userIdList: [],
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 15,
        page: 1
      },
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'สิทธิ์', value: 'authenName' },
        { text: 'ผู้โอนสิทธิ์', value: 'nameTh' },
        { text: 'วันที่โอนสิทธิ์', value: 'createAt' },
        { text: 'ระยะเวลาที่โอนสิทธิ์', value: 'dateRange' },
        { text: 'ใกล้หมดอายุ', value: 'expire' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '80px', align: 'center fixed', class: 'column-fix' }
      ],
      dataSource: [
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageAuthen')
  },
  mounted () {
    EventBus.$on('openDialogManageAuthen', this.openDialogManageAuthen)
  },
  computed: {
    checkBtnSubmit () {
      if (this.selected.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    onImgError () {
      this.failed_image = true
    },
    async openDialogManageAuthen (value) {
      // this.onImgError()
      // console.log('Data Dialog add approver :', value, type, item, action, index)
      this.loading = true
      this.searchEmpoyee = ''
      this.dataSearchEmployee = ''
      this.dialogMangeAuthen = value
      await this.setFilter()
    },
    closeDialog () {
      // this.clearSearchEmployee()
      this.resetFilterData()
      this.dialogMangeAuthen = false
      this.dataSource = []
    },
    resetFilterData () {
      this.search = ''
      this.selected = []
    },
    async confirmUpdate () {
      this.dialogMangeAuthen = false
      this.dataSource = []
      const self = this
      var confirmList = []
      self.selected.forEach(e => {
        confirmList.push(e._id)
      })
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/authenTransfer/reUpdateTransfer`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            this.$router.go(0)
            this.dialogMangeAuthen = false
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    async setFilter (value) {
      if (this.filterData.role) this.approveRole = this.filterData.role
      this.filterData = value
      var searchPayload = {
        search: '',
        authenId: [],
        limit: this.perPage,
        page: this.page
      }
      // this.initSelectData()
      this.searchFilterData(searchPayload)
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.$store.state.token
      try {
        const res = await getSelectManageAuthen(token)
        if (res.success) {
          this.itemUser = res.result.name
          this.authenItem = res.result.authen
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async searchFilterData (value) {
      const self = this
      self.loading = true
      self.selected = []
      self.filterData = value
      try {
        const res = await fetchAllRequestAuthen(value, this.$store.state.token)
        if (res.success) {
          self.total = res.count || -1
          self.dataSource = res.result || []
          self.computeData(self.dataSource)
        } else {
          self.dataSource = []
        }
      } catch (error) {
        console.log(error)
        self.dataSource = []
      } finally {
        self.loading = false
      }
    },
    checkCancel (val) {
      this.userIdList = val.userId
      this.propsitems = val._id
      this.dialogConfirmCancel = true
    },
    async submitCancelRole () {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/cancelAuthen`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsitems
        }
      }).then(async (response) => {
        if (response.data.success) {
          swal('สำเร็จ', 'ยกเลิกสิทธิ์สำเร็จ', 'success', {
            button: false,
            timer: 1000
          })
          var searchPayload = {
            search: '',
            authenId: [],
            limit: this.perPage,
            page: this.page
          }
          const resCheck = await fetchAllRequestAuthen(searchPayload, this.$store.state.token)
          if (resCheck.success) {
            if (resCheck.result.length > 0) {
              this.setFilter()
            } else {
              this.$router.go(0)
            }
          }
          this.loading = false
          this.dialogConfirmCancel = false
        } else {
          swal('ผิดพลาด', 'ยกเลิกสิทธิ์ไม่สำเร็จ', 'error', {
            button: false,
            timer: 1500
          })
        }
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.startDate = moment(e.startDate).format('DD/MM/YYYY HH:mm น.')
        e.endDate = moment(e.endDate).format('DD/MM/YYYY HH:mm น.')
      })
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          self.selected.push(item)
        })
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
